import { user } from 'src/StateObserver';
import { LockedReason } from 'src/game/popups/PopupFeatureDisabled';
import NotificationBadge from '../shared/NotificationBadge';
import { getFriendshipRequestsCount } from 'src/replicant/friends/friends.getters';
import { waitAFrame } from 'src/game/minigame/match2-timestep/lib/util/waitAFrame';
import { updateTeamNotificationBadge } from 'src/game/minigame/match2-timestep/team/team.utils';

export type LockedStatus =
  | {
      locked: true;
      reason?: LockedReason;
      callback?: () => void | Promise<void>;
    }
  | { locked: false; reason?: undefined };

/**
 * Get the locked status of the menu button.
 */
export function getMenuLocked(): LockedStatus {
  return { locked: false };
}

/**
 * Get the locked status of the shop button.
 */
export function getShopLocked(): LockedStatus {
  return { locked: false };
}

/**
 * Updates a badge with the number of pending friend requests or unread team messages in the team chat.
 * @param badge - The badge to update.
 * @param persist - Whether to wait for the user to join a team if they are not in one.
 * @returns
 */
export async function updateFriendsFooterNotificationBadge(
  stop: VoidFunction,
  badge: NotificationBadge,
  persist = false,
) {
  const friendRequestsCount = getFriendshipRequestsCount(user());

  // Prioritize showing friend requests RDN
  if (friendRequestsCount) {
    badge.show();
    badge.updateStyle('red');
    badge.setText(friendRequestsCount.toString());

    // Wait a number of frames to ensure the badge updates correctly but not too frequently.
    await waitAFrame(60);

    return;
  }

  // Otherwise, do the team related RDN/GDN.
  await updateTeamNotificationBadge(stop, badge, persist);
}
